import { API } from "@/services/api";
import { billingEndpoints } from "@/constant/endpoints";
import { IAPIResponse } from "@/services/api.types";
import {
  AddonPreviewFormData,
  AddonPreviewResponse,
  AddonUpdateFormData,
  AddonUpdateResponse,
  BillingPlansResponse,
  BillingStatusResponse,
  CheckoutFormData,
  CheckoutResponse,
  CheckoutStatusResponse,
  ContactInquiryFormData,
  ContactInquiryResponse,
  PortalFormData,
  PortalResponse,
} from "@/types/billing.types";

export const getBillingPlansService = async (): Promise<BillingPlansResponse> => {
  const response = await API.Get<BillingPlansResponse>(billingEndpoints.plans);
  if (response.data) return response.data;
  throw new Error(response.message);
};

export const postContactInquiryService = async (
  payload: ContactInquiryFormData
): Promise<IAPIResponse<ContactInquiryResponse>> => {
  return API.Post<ContactInquiryFormData, ContactInquiryResponse>(billingEndpoints.contact, payload);
};

export const getBillingStatusService = async (): Promise<BillingStatusResponse> => {
  const response = await API.Get<BillingStatusResponse>(billingEndpoints.status);
  if (response.data) return response.data;
  throw new Error(response.message);
};

export const postCheckoutService = async (payload: CheckoutFormData): Promise<IAPIResponse<CheckoutResponse>> => {
  return API.Post<CheckoutFormData, CheckoutResponse>(billingEndpoints.checkout, payload);
};

export const postPortalService = async (payload: PortalFormData): Promise<IAPIResponse<PortalResponse>> => {
  return API.Post<PortalFormData, PortalResponse>(billingEndpoints.portal, payload);
};

export const postAddonUpdateService = async (
  payload: AddonUpdateFormData
): Promise<IAPIResponse<AddonUpdateResponse>> => {
  return API.Post<AddonUpdateFormData, AddonUpdateResponse>(billingEndpoints.addons, payload);
};

export const postAddonPreviewService = async (
  payload: AddonPreviewFormData
): Promise<IAPIResponse<AddonPreviewResponse>> => {
  return API.Post<AddonPreviewFormData, AddonPreviewResponse>(billingEndpoints.addonsPreview, payload);
};

export const getCheckoutStatusService = async (sessionId: string): Promise<CheckoutStatusResponse> => {
  const response = await API.Get<CheckoutStatusResponse>(billingEndpoints.checkoutStatus(sessionId));
  if (response.data) return response.data;
  throw new Error(response.message);
};
